<template>
    <v-container fluid pa-0 v-if="!$store.getters.progress" style="padding-bottom: 10% !important">
        <v-layout row wrap>
            <v-flex xs12>
                <v-card class="flex pa-0">
                    <v-toolbar flat color="grey lighten-4">
                        <v-toolbar-title class="grey--text text--darken-4">Dettaglio Trattamento</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <v-btn @click="$eventBusUtility.goTo($router, 'products-edit', model.id)" slot="activator" icon>
                                <v-icon color="primary">mode_edit</v-icon>
                            </v-btn>
                            <span>Modifica Trattamento</span>
                        </v-tooltip>                                   
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-container fluid pa-0 px-2>
                        <v-layout row :wrap="$vuetify.breakpoint.smAndDown">
                            <v-flex xs12 sm12 md6 lg6>
                                <v-list two-line class="w100p">
                                <v-subheader>Trattamento</v-subheader>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">local_offer</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Nome</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.name }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>                                    
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">euro_symbol</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Prezzo</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.price | currency }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>                                    
                                    <v-list-tile>
                                        <v-list-tile-avatar class="v-avatar-show">
                                            <v-avatar v-if="model.creator_avatar"
                                                class="custom-avatar"
                                                :size="26" 
                                                v-ripple
                                                :style="{'background-image': 'url(' + model.creator_avatar + ')'}">
                                            </v-avatar>
                                            <v-avatar v-else :class="$eventBusUtility.bgColor(model.creator_id)" :size="26">
                                                <span class="white--text fs14" v-if="model.creator">{{ model.creator.charAt(0) }}</span>
                                            </v-avatar>
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Creatore</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.creator }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>                               
                                </v-list>
                            </v-flex>
                            
                            <v-divider vertical class="hidden-sm-and-down"></v-divider>

                            <v-flex xs12 sm12 md6 lg6>
                                <v-list two-line class="w100p">
                                <v-subheader>Categoria</v-subheader>
                                    <v-list-tile @click="$eventBusUtility.goTo($router, 'productcategories-edit', model.productcategory_id)">
                                        <v-list-tile-action>
                                            <v-icon color="primary">widgets</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Categoria</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.productcategory_name }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
										    <v-btn icon>
										        <v-icon color="grey lighten-1">keyboard_arrow_right</v-icon>
										    </v-btn>
										</v-list-tile-action>
                                    </v-list-tile>                                                                             
                                </v-list>
                            </v-flex>
                        </v-layout>
                        <v-divider v-if="model.description"></v-divider>
                        <v-layout row wrap pt-2 pb-2 v-if="model.description">
                            <template>
                                <v-subheader class="pl-4 pt-3">Descrizione</v-subheader>
                                <v-flex xs12>
                                    <v-card class="flex" elevation="0">
                                        <div class="blockquote pl-4 pr-4 fs14i" v-html="model.description"></div>
                                    </v-card>
                                </v-flex>
                            </template>     
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
export default {
	name: 'product',
	props: {
		id: Number
	},

	data() {
		return {
			model: {},
			url: 'products/',
			saved: false
		}
	},

	created() {
		this.axios.get(this.url + this.id).then(response => {
			// get body data
			this.model = response.data.model
			this.$store.commit('endProgress')
		},
		response => {
			// error callback
		})
	}
}
</script>

<style scoped>
div >>> .v-list__tile {
  height: 58px;
  -webkit-user-select: auto;
  user-select: auto;
}
</style>
